import {
  Diamond, Droplet, Eye, FastForward, Feather, Footprints, Ghost, Heart, Minus, Plus, Shield,
  ShieldCheck, Skull, Sword, Swords, Target, TreePine, Zap,
} from 'lucide-react';
import { DefenseIcon, LoyaltyIcon } from '../../../ui/CardSymbolIcons';

/**
 * Anzeigenamen und Symbole der Karten-Counter und -Marker — einzige Quelle für Kontextmenü,
 * Brettkarten-Badges und Werte-Panels (Schlüssel = Server-Typen aus
 * `backend/services/playtestStateManager.ts`, CARD_COUNTER_TYPES / CARD_MARKER_TYPES).
 */
export const COUNTER_LABELS = {
  '+1/+1': '+1/+1',
  '-1/-1': '-1/-1',
  loyalty: 'Loyalität',
  defense: 'Verteidigung',
  poison: 'Gift',
  energy: 'Energie',
  generic: 'Generisch',
};

export const MARKER_LABELS = {
  flying: 'Fliegend',
  haste: 'Eile',
  vigilance: 'Wachsamkeit',
  deathtouch: 'Todesberührung',
  lifelink: 'Lebensverknüpfung',
  'first-strike': 'Erstschlag',
  'double-strike': 'Doppelschlag',
  trample: 'Trampelschaden',
  reach: 'Reichweite',
  defender: 'Verteidiger',
  hexproof: 'Fluchsicherheit',
  indestructible: 'Unzerstörbar',
  menace: 'Bedrohlich',
};

/**
 * Reihenfolge und Symbole der Karten-Counter; Schlüssel wie `COUNTER_LABELS`. Counter und Marker
 * stehen in derselben Badge-Spalte der Brettkarte: kein Symbol kommt dort zweimal vor (Gift wie die
 * Gift-Marke der Teilnehmer als Tropfen, der Totenkopf gehört der Todesberührung).
 */
export const CARD_COUNTER_ICONS = [
  ['+1/+1', Plus],
  ['-1/-1', Minus],
  ['loyalty', LoyaltyIcon],
  ['defense', DefenseIcon],
  ['poison', Droplet],
  ['energy', Zap],
  ['generic', Target],
];

/** Reihenfolge und Symbole der Marker (je Marker ein eigenes); Schlüssel wie `MARKER_LABELS`. */
export const CARD_MARKER_ICONS = [
  ['flying', Feather],
  ['haste', FastForward],
  ['vigilance', Eye],
  ['deathtouch', Skull],
  ['lifelink', Heart],
  ['first-strike', Sword],
  ['double-strike', Swords],
  ['trample', Footprints],
  ['reach', TreePine],
  ['defender', ShieldCheck],
  ['hexproof', Shield],
  ['indestructible', Diamond],
  ['menace', Ghost],
];
